module.exports = __webpack_public_path__ + "media/images/frontend/banner_1000x220_3-1e55d211e175b82cd52d0c2d98b04706.png";